import { Location } from '@angular/common';
import { AfterContentInit, Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { db } from 'src/app/db/db';
import { EEntreeZoneType } from 'src/app/domain/enums/entree-zone';
import { EEPIType } from 'src/app/domain/enums/epi-type';
import { EExpositionClimatique } from 'src/app/domain/enums/exposition-climatique';
import { EIntegriteType } from 'src/app/domain/enums/integrite-type';
import { EMeteoType } from 'src/app/domain/enums/meteo-type';
import { ETetePrelevement } from 'src/app/domain/enums/tete-prelevement';
import { PlageHoraire } from 'src/app/domain/plage-horaire';
import { Pompe } from 'src/app/domain/pompe';
import { ZoneMeasure } from 'src/app/domain/zone-measure';
import { ENavigationRoute } from 'src/app/model/enum/navigation-route';
import { CoreData } from 'src/app/tools/core-data/core-data';
import { StringTool } from 'src/app/tools/mapping/string.tool';
import { CopyPlageHorraireBetweenZonesBoxDialog } from 'src/app/tools/ui/copy-ph-between-zones-box/copy-ph-between-zones-box';
import { EditTextBoxDialog } from 'src/app/tools/ui/edit-text-box/edit-text-box';
import { NotificationManager } from 'src/app/tools/ui/notification-manager';
import { PlageHoraireBoxDialog } from 'src/app/tools/ui/plage-horaire-box/plage-horaire-box';
import { StringConverter } from 'src/app/tools/ui/string-converter';

@Component({
    selector: 'app-zone',
    templateUrl: './zone.component.html',
    styleUrls: ['./zone.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ZoneComponent implements OnInit, AfterContentInit {
    EExpostionClimatique = EExpositionClimatique;
    public TetePrelevementList: string[] = Object.values(ETetePrelevement)
        .filter(x => !isNaN(Number(x)))
        .map((x: any) => StringConverter.getTetePrelevementTypeName(x));

    public MeteoList: string[] = Object.values(EMeteoType)
        .filter(x => !isNaN(Number(x)))
        .map((x: any) => StringConverter.getMeteoTypeName(x));

    public EntreZoneList: string[] = Object.values(EEntreeZoneType)
        .filter(x => !isNaN(Number(x)))
        .map((x: any) => StringConverter.getEntreZoneTypeName(x));

    public EPIList: string[] = Object.values(EEPIType)
        .filter(x => !isNaN(Number(x)))
        .map((x: any) => StringConverter.getEPITypeName(x));

    public IntegriteList: string[] = Object.values(EIntegriteType)
        .filter(x => !isNaN(Number(x)))
        .map((x: any) => StringConverter.getIntegriteTypeName(x));

    public ExpositionClimatiqueList: string[] = Object.values(EExpositionClimatique)
        .filter(x => !isNaN(Number(x)))
        .map((x: any) => StringConverter.getExpositionClimatiqueTypeName(x));

    private mrCode: string | undefined;
    private zoneCode: string | undefined;
    public isDepose: boolean | undefined;
    Measure!: ZoneMeasure;

    ValidMinutesForHoraireInitial = new UntypedFormControl('', Validators.compose([Validators.min(0), Validators.max(59)]));
    ValidMinutesForHoraireFinal = new UntypedFormControl('', Validators.compose([Validators.min(0), Validators.max(59)]));

    CompteurAvecHeure: boolean = false;
    CompteurHoraireInitialHeures: number | undefined;
    CompteurHoraireInitialMinutes: number | undefined;
    CompteurHoraireFinalHeures: number | undefined;
    CompteurHoraireFinalMinutes: number | undefined;

    constructor(
        private location: Location,
        private router: Router,
        private coreData: CoreData,
        private snackBar: MatSnackBar,
        private dialog: MatDialog,
        private route: ActivatedRoute) {

    }

    ngOnInit(): void {
        this.mrCode = this.route.snapshot.params?.['measureCode'];
        this.zoneCode = this.route.snapshot.params?.['zoneCode'];
        this.isDepose = Boolean(JSON.parse(this.route.snapshot.params?.['isDepose']));

        this.ValidMinutesForHoraireInitial.markAsTouched();
        this.ValidMinutesForHoraireFinal.markAsTouched();
    }

    async ngAfterContentInit(): Promise<void> {
        this.Measure = await db.getZoneMeasureByCodeWithChildren(this.mrCode!, this.isDepose!);

        if (this.coreData.ScannedCassetteCode && this.coreData.ScannedId) {
            this.Measure.Cassette.Reference = this.coreData.ScannedCassetteCode;
            this.coreData.ScannedId = '';
            this.coreData.ScannedCassetteCode = '';
            this.save(true);
        }
        if (this.coreData.ScannedPompeCode && this.coreData.ScannedId) {
            this.Measure.Cassette.Pompe.Reference = this.coreData.ScannedPompeCode;
            this.coreData.ScannedId = '';
            this.coreData.ScannedPompeCode = '';
            this.save(true);
        }
    }

    checkBarCode(barCode: string) {
        if (!barCode || barCode === '')
            return true;
        var regex = /^([A-Za-z0-9]{5,7}[:-][A-Za-z0-9]{5,8}|[A-Za-z0-9]{5,6}-[A-Za-z0-9]{5}|[A-Za-z0-9]{6,8}[ ]{0,2}-[A-Za-z0-9]{5}|[A-Za-z0-9]{7}-[A-Za-z0-9]{4}-[A-Za-z0-9]{6})$/g
        let success = regex.test(barCode)

        return success
    }

    async ExpositionClimatiqueChange(event: MatSelectChange) {

        if (event.value === EExpositionClimatique.Interieur) {
            this.Measure.ZoneSamplingCondition.Hygrometrie = undefined;
            this.Measure.ZoneSamplingCondition.Meteo = undefined;
            this.Measure.ZoneSamplingCondition.VitesseVent = undefined;
        }
    }

    onInitialHeuresChangeEvent(p: Pompe) {

        if (this.CompteurHoraireInitialHeures === undefined) {
            return;
        }
        p.CompteurHoraireInitial = this.CompteurHoraireInitialHeures * 60 + (this.CompteurHoraireInitialMinutes ?? 0);
    }

    onInitialMinutesChangeEvent(p: Pompe) {
        if (this.CompteurHoraireInitialHeures === undefined) {
            return;
        }
        p.CompteurHoraireInitial = this.CompteurHoraireInitialHeures * 60 + (this.CompteurHoraireInitialMinutes ?? 0);
    }

    onFinalHeuresChangeEvent(p: Pompe) {
        if (this.CompteurHoraireFinalHeures === undefined) {
            return;
        }
        p.CompteurHoraireFinal = this.CompteurHoraireFinalHeures * 60 + (this.CompteurHoraireFinalMinutes ?? 0);
    }

    onFinalMinutesChangeEvent(p: Pompe) {
        if (this.CompteurHoraireFinalHeures === undefined) {
            return;
        }
        p.CompteurHoraireFinal = this.CompteurHoraireFinalHeures * 60 + (this.CompteurHoraireFinalMinutes ?? 0);
    }

    computeDebitMoy(pompe: Pompe) {
        return this.computeVolumeTotal(pompe) / this.computeDureeTotal(pompe);
    }

    computeDebitMoyInf10Percent(pompe: Pompe) {
        return Math.abs(pompe.DebitFinal - pompe.DebitInitial) * 100 / pompe.DebitInitial < 10 ? 'OUI' : 'NON'
    }

    computeVolumeTotal(pompe: Pompe) {
        return pompe.CompteurVolFinal - pompe.CompteurVolInitial;
    }

    computeDureeTotal(pompe: Pompe) {
        return pompe.CompteurHoraireFinal - pompe.CompteurHoraireInitial;
    }

    deletePlage(ph: PlageHoraire) {
        _.remove(this.Measure.Cassette.PlageHoraireList, ph);
        NotificationManager.handleSuccess('Plage horaire suprimée', this.snackBar);
    }

    openPlageHoraireDialog() {

        const dialogRef = this.dialog.open(PlageHoraireBoxDialog, {
            data: {},
            width: '777px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.Measure.Cassette.PlageHoraireList.push(result);
                NotificationManager.handleSuccess('Plage horaire ajoutée', this.snackBar);
            }
        });
    }

    openCopyPlageHoraireBox() {
        const dialogRef = this.dialog.open(CopyPlageHorraireBetweenZonesBoxDialog, {
            data: {
                zoneCode: this.zoneCode,
                currentMeasureCode: this.Measure.Code,
                isDepose: this.isDepose
            },
            width: '777px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe((result: ZoneMeasure) => {
            if (result) {
                this.Measure.Cassette.PlageHoraireList = [];
                this.Measure.Cassette.PlageHoraireList = result.Cassette.PlageHoraireList;
                if (result.IsDepose)
                    this.Measure.DeposeSecurite = result.DeposeSecurite
                else
                    this.Measure.PoseSecurite = result.PoseSecurite

                this.Measure.ZoneSamplingCondition = result.ZoneSamplingCondition
                NotificationManager.handleSuccess('Plage horaire copiée', this.snackBar);
            }
        });
    }

    openBarcodeScanning(cassetteId: number, isForPompe: boolean) {
        this.save(true);
        this.coreData.ScannedId = `${cassetteId}`;
        this.router.navigate([ENavigationRoute.Scan, { isForPompe: isForPompe }]);
    }

    cancelMeasure() {
        const dialogRef = this.dialog.open(EditTextBoxDialog, { data: { title: 'Veuillez indiquer le motif de l\'annulation', withCancelButton: true } });
        dialogRef.afterClosed().subscribe(async (result: string) => {
            if (result) {
                await db.cancelledZoneMeasure(this.Measure, result);
                NotificationManager.handleSuccess('Mesure annulée', this.snackBar);
                this.location.back()
            }
        })
    }

    canSave() {
        if (!StringTool.isNotNullOrEmpty(this.Measure.Cassette.Reference) || !this.checkBarCode(this.Measure.Cassette.Reference)) {
            return false;
        }
        return true;
    }

    async save(quiet?: boolean) {
        // await db.clearZoneMeasureWithChildren(this.Measure);
        const success = await db.updateMeasure(this.Measure);
        if (success && !quiet) {
            NotificationManager.handleSuccess('Mesure enregistrée', this.snackBar);
            this.location.back()
        } else if (!success) {
            NotificationManager.handleError('Wasted Bro!', this.snackBar);
        }
    }

    getTotal() {
        if (this.Measure.Cassette.PlageHoraireList.length === 0)
            return;
        return _.sum(this.Measure.Cassette.PlageHoraireList.map(x => x.Fin.since(x.Debut, { largestUnit: 'minutes' }).minutes));
    }
}

